import React from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import { SideSpacer } from '../../components/common/Spacer';
import MemberContainer from '../../containers/member/MemberContainer';
import {
  HorizonWrapper,
  CommonContainer,
} from '../../components/common/Container';

const MemberPage = () => {
    
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <HorizonWrapper>
          <CommonContainer>
            <MemberContainer />
          </CommonContainer>
        </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default MemberPage;
